import { request } from './client'

export interface ItineraryLeg {
  id: number
  carrier_id: number
  carrier_name?: string
  voyage_id: string | null
  leg_number: number
  from_port: string
  from_datetime: string
  to_port: string
  to_datetime: string
  status: 'planned' | 'en_route' | 'completed'
  notes: string | null
  created_by: number | null
  updated_by: number | null
  created_at: string
  updated_at: string
}

export interface FleetItinerary {
  carrier_id: number
  carrier_name: string
  legs: ItineraryLeg[]
  current_leg: ItineraryLeg | null
  next_leg: ItineraryLeg | null
}

export interface ReviewStatus {
  reviewed: boolean
  last_reviewed: string | null
}

export const itinerary = {
  list: (carrierId: number) =>
    request<ItineraryLeg[]>(`/itinerary?carrier_id=${carrierId}`),

  fleet: () =>
    request<FleetItinerary[]>('/itinerary/fleet'),

  create: (data: {
    carrier_id: number
    from_port: string
    from_datetime: string
    to_port: string
    to_datetime: string
    voyage_id?: string
    notes?: string
    leg_number?: number
  }) =>
    request<ItineraryLeg>('/itinerary', { method: 'POST', body: JSON.stringify(data) }),

  update: (legId: number, data: Partial<{
    from_port: string
    from_datetime: string
    to_port: string
    to_datetime: string
    voyage_id: string
    notes: string
    status: string
    leg_number: number
  }>) =>
    request<ItineraryLeg>(`/itinerary/${legId}`, { method: 'PATCH', body: JSON.stringify(data) }),

  delete: (legId: number) =>
    request<{ status: string }>(`/itinerary/${legId}`, { method: 'DELETE' }),

  reviewStatus: () =>
    request<ReviewStatus>('/itinerary/review-status'),

  submitReview: (notes?: string) =>
    request<{ status: string }>('/itinerary/review', { method: 'POST', body: JSON.stringify({ notes }) }),

  current: () =>
    request<FleetItinerary[]>('/itinerary/current'),

  syncFromVoyages: (carrierId: number) =>
    request<{ synced: number; carrier_id?: number; carrier_name?: string; message?: string }>(
      `/itinerary/sync-from-voyages?carrier_id=${carrierId}`,
      { method: 'POST' }
    ),
}
